export function isMobileWindow(): boolean {
  return window.innerWidth <= 768 ? true : false
}
